import { css } from "@emotion/react";
import { Theme } from "@mui/material";

interface DrawerMaxWidthProps {
  drawerMaxWidth: number;
}

interface AppBarHeightProps {
  appBarHeight: number;
}

type DrawerStyleProps = DrawerMaxWidthProps;

export const menuDrawerStyles = {
  drawerContainer: ({ appBarHeight }: AppBarHeightProps) =>
    css({
      position: "absolute",
      top: appBarHeight,
      left: 0,
      height: "calc(-100% + 100vh)",
    }),
  drawer:
    ({ drawerMaxWidth }: DrawerStyleProps) =>
    (theme: Theme) =>
      css({
        position: "relative",
        height: "100%",
        transform: "translateX(-100%)",
        width: `min(100vw, ${drawerMaxWidth}px)`,
        borderColor: theme.palette.divider,
        color: theme.palette.text.primary,
        colorScheme: theme.palette.mode,
        background: theme.palette.background.paper,
        overflowY: "auto",
        "ul,nav": {
          marginLeft: 0,
          marginRight: 0,
          paddingTop: 0,
          paddingBottom: 0,
        },
      }),
  subMenuDrawer: ({ drawerMaxWidth }: DrawerMaxWidthProps) =>
    css({
      position: "absolute",
      left: `min(100vw, ${drawerMaxWidth}px)`,
    }),
  slide: css({
    transform: "translateX(0)",
  }),
  transition: css({
    transition: "transform 200ms ease-in-out",
  }),
  hide: css({
    display: "none",
  }),
};
